function indentStackTrace(stackTrace: string) {
    const indent = '    ';

    const newStackTrace = stackTrace
        .split('\n')
        .map((line: string) => `${indent}${line}`)
        .join('\n');

    return newStackTrace;
}

type Context = object;

interface AppErrorArgs {
    message: string;
    context?: Context | Context[];
    previousError?: Error | AppError;
}

// Based on https://gist.github.com/justmoon/15511f92e5216fa2624b

// TODO: Investigate how this would work in browser.
// Error.captureStackTrace might not always exist.
// How to add AppError to window object?
export class AppError extends Error {
    context: Context[];

    // This constructor is unusually complex so it violates the complexity rule.
    // eslint-disable-next-line complexity
    constructor({ message, context, previousError }: AppErrorArgs) {
        super();

        if (!message || typeof message !== 'string') {
            throw new Error('message required by AppError');
        }

        if (Error.captureStackTrace) {
            // Creates a .stack property on targetObject, which when accessed returns a string representing
            // the location in the code at which Error.captureStackTrace() was called.
            // https://nodejs.org/api/errors.html#errors_error_capturestacktrace_targetobject_constructoropt
            Error.captureStackTrace(this, this.constructor);
        }

        this.name = 'AppError';
        this.message = message;
        this.context = [];

        if (context) {
            this.context = [context];
        }

        if (previousError instanceof AppError && previousError?.context) {
            this.context = [...this.context, ...previousError.context];
        }

        if (previousError?.stack) {
            this.stack = `${this.stack}\n\n${indentStackTrace(
                previousError.stack
            )}`;
        }

        if (previousError && previousError.message) {
            this.message = `${this.message} > ${previousError.message}`;
        }
    }
}
